/**
 * CollapsedPill — Tappable summary of a completed wizard step.
 * Shows icon badge, label, summary text, and chevron.
 */

import type { ReactNode } from 'react';
import { T } from '@/styles/tokens';

interface CollapsedPillProps {
  icon: ReactNode;
  label: string;
  summary: string;
  onTap: () => void;
}

export function CollapsedPill({ icon, label, summary, onTap }: CollapsedPillProps) {
  return (
    <button
      onClick={onTap}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        width: '100%',
        padding: '10px 14px',
        borderRadius: 14,
        border: `1.5px solid ${T.border}`,
        background: T.white,
        cursor: 'pointer',
        fontFamily: T.fontFamily,
        marginBottom: 8,
        transition: 'all 0.15s ease',
        boxShadow: '0 1px 2px rgba(0,0,0,0.03)',
      }}
    >
      <div style={{
        width: 32,
        height: 32,
        borderRadius: 9,
        background: T.tealSoft,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}>
        {icon}
      </div>
      <div style={{ flex: 1, textAlign: 'left' }}>
        <div style={{
          fontSize: 11,
          fontWeight: 600,
          color: T.charcoal300,
          textTransform: 'uppercase',
          letterSpacing: '0.04em',
          lineHeight: 1,
          marginBottom: 2,
        }}>
          {label}
        </div>
        <div style={{
          fontSize: 14,
          fontWeight: 600,
          color: T.text,
          lineHeight: 1.3,
        }}>
          {summary}
        </div>
      </div>
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0 }}>
        <path d="M4 6l4 4 4-4" stroke={T.charcoal300} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  );
}
